<template>
    <div>
        <p>Cette fonction vous permet de générer un lien VIP à usage multiple. Lorsqu'un utilisateur ouvre ce lien, une copie de la configuration de ce lien d'inscription ci-dessous sera créée.</p>
        <v-form ref="formCreateLienVIP" v-model="valid" class="mb-5">
            <v-row>

                <v-col md="5" cols="12">
                    <label class="field_label">Nombre de participants qui peuvent être inscrit avec ce code<span
                            class="text-red">*</span></label>
                    <v-text-field type="number" v-model="lien_VIP.nb_inscrits" required></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                    <label class="field_label">Date d'expiration</label>
                    <v-text-field type="date" v-model="lien_VIP.date_expiration"></v-text-field>
                </v-col>
            </v-row>

            <v-row v-if="mainStore.module.autorise_acces_billetterie">
                <v-col cols="6">
                    <label class="field_label">Lien privilégié pour le module en version Billetterie<span
                            class="text-red">*</span></label>
                    <div>En cochant <b>Oui</b>, le destinataire recevra un lien pour s'inscrire sur
                        https://sportips.fr/BILLETTERIE_{{ mainStore.module.base }}/</div>
                    <v-select :items="items" v-model="lien_VIP.for_billetterie"></v-select>
                </v-col>
            </v-row>
            <v-row v-if="mainStore.module.courses.list.length > 0">
                <v-col cols="12">
                    <div class="text-h6">Les parcours</div>
                </v-col>
                <v-col md="3" cols="12">
                    <label class="field_label">Le destinataire devra payer l'inscription aux parcours<span
                            class="text-red">*</span></label>
                    <v-select :items="items" v-model="lien_VIP.doit_payer_course"></v-select>
                </v-col>
                <v-col md="9" cols="12">
                    <label class="field_label">Quels parcours doivent être disponible à l'inscription (même si complets)
                        ?</label>
                    <v-alert v-if="lien_VIP.limit_acces_parcours" border="start" border-color="primary-dark"
                        elevation="1">Le
                        choix de parcours sera limité à : {{ list_filtered_parcours }}</v-alert>
                    <v-alert v-else border="start" border-color="primary-dark" elevation="1">En ne limitant à aucun
                        parcours, le
                        participant pourra s'inscrire au parcours de son choix</v-alert>

                    <div>
                        <div class="d-inline-flex justify-start flex-wrap">
                            <v-checkbox class="mr-4" v-for="course in availables_parcours" v-model="course.selected"
                                hide-details density="compact" :label="course.nom" :key="course.id"></v-checkbox>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <div class="text-h6">Les options</div>
                </v-col>
                <v-col md="3" cols="12">
                    <label class="field_label">Le destinataire devra payer l'inscription aux options<span
                            class="text-red">*</span></label>
                    <v-select :items="items" v-model="lien_VIP.doit_payer_option"></v-select>
                </v-col>
                <v-col md="3" cols="12">
                    <label class="field_label">Le destinataire pourra s'inscrire aux options complètes<span
                            class="text-red">*</span></label>
                    <v-select :items="items" v-model="lien_VIP.acces_options_completes"></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="text-h6">Les activités</div>
                </v-col>
                <v-col md="3" cols="12">
                    <label class="field_label">Le destinataire devra payer l'inscription aux activités<span
                            class="text-red">*</span></label>
                    <v-select :items="items" v-model="lien_VIP.doit_payer_activite"></v-select>
                </v-col>
                <v-col md="3" cols="12">
                    <label class="field_label">Le destinataire pourra s'inscrire aux activités complètes<span
                            class="text-red">*</span></label>
                    <v-select :items="items" v-model="lien_VIP.acces_activites_completes"></v-select>
                </v-col>
            </v-row>

            <div class="d-flex justify-center mt-3">
                <v-btn color="primary-dark" @click="validate()">Créer le lien multi usage</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Lien_VIP from "@/classes/Lien_VIP/Lien_VIP.class";
export default {
    data() {
        return {
            lien_VIP: new Lien_VIP(),
            valid: false,
            items: [
                { title: "0ui", value: 1 },
                { title: "Non", value: 0 },
            ],
            availables_parcours: [],
            list_courses: {},
            list_packs_courses: {},
        };
    },
    watch: {
        "lien_VIP.filter_parcours": {
            handler: function (val) {
                this.lien_VIP.limit_acces_parcours = val.filter((course) => course.selected).length > 0;
            },
            deep: true,
        },
        availables_parcours: {
            handler: function (val) {
                this.lien_VIP.filter_parcours = val.filter((course) => course.selected);
            },
            deep: true,
        },
    },

    computed: {
        ...mapStores(useMainStore),
        list_filtered_parcours() {
            return this.lien_VIP.filter_parcours
                .filter((course) => course.selected)
                .map((course) => course.nom)
                .join(", ");
        },
    },
    methods: {
        build_available_parcours() {
            this.availables_parcours = this.mainStore.module.courses.list.map((course) => {
                return {
                    id: course.id,
                    nom: course.nom,
                    selected: false,
                };
            });
        },
        async validate() {
            let response = await this.$refs.formCreateLienVIP.validate();
            if (response.valid) {
                this.lien_VIP.id_module = this.mainStore.module.id;
                await this.lien_VIP.post();
                this.$router.go();
            }
        },
    },
    async created() {
        this.build_available_parcours();
    },
};
</script>

<style lang="scss" scoped></style>